export enum ClientId_SHOPPER {
    TT = 'shop-tt-u2YiYPmDUTu4MvHGE2q9',
    SIT = 'g46x7hvQBnRW6KB3s7mF',
    DEV = 'J9m9ygS6G4T1G11ocWyK',
    UAT = 'oeVYL9sR9NBOYAhlNzpZ',
    PROD = 'DHW5rlt5yKDBkgyJKDts'
}


export enum ClientId_MEMBER {
    TT = '2UlJkfcs6bvnPRnV4qLe',
    SIT = 'wNEmjvaHUO1ahuwl1I6W',
    DEV = '6jMBSWsLj7TIyEetx71l',
    UAT = 'dC1m9fr7kNYVpfnJpk72',
    PROD = 'qW23dnBDurVQ1T158uUp'
}



// WEBPACK FOOTER //
// ./src/app/login/client_id.ts